import { z } from "zod";

const scanToCreateHeaderSchema = z.object({
	header: z.string(),
	characterCount: z.number(),
});
export type ScanToCreateHeader = z.infer<typeof scanToCreateHeaderSchema>;

export const scanToCreateConfigurationSchema = z.object({
	delimiter: z.string().optional(),
	headers: z.array(scanToCreateHeaderSchema),
	isDelimiterBased: z.boolean(),
});
export type ScanToCreateConfiguration = z.infer<typeof scanToCreateConfigurationSchema>;
